import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { ChargeSchema } from '../billing/charge.ts'
import { PaymentSchema } from '../payment/payment.ts'

export const PaymentTransactionSchema = z.object({
  transactionKind: z.literal('payment'),
  payment: PaymentSchema,
})
export type PaymentTransaction = ZodSimplify<typeof PaymentTransactionSchema>

export const ChargeTransactionSchema = z.object({
  transactionKind: z.literal('charge'),
  charge: ChargeSchema,
})

export type ChargeTransaction = ZodSimplify<typeof ChargeTransactionSchema>

export const TransactionSchema = z.discriminatedUnion('transactionKind', [
  PaymentTransactionSchema,
  ChargeTransactionSchema,
])

export type Transaction = ZodSimplify<typeof TransactionSchema>

export function transactionIsCharge(
  transaction?: Transaction
): transaction is Transaction & { transactionKind: 'charge' } {
  return transaction?.transactionKind === 'charge'
}

export function transactionIsPayment(
  transaction?: Transaction
): transaction is Transaction & { transactionKind: 'payment' } {
  return transaction?.transactionKind === 'payment'
}

export function assertTransactionIsCharge(
  transaction?: Transaction
): asserts transaction is Transaction & { transactionKind: 'charge' } {
  if (!transactionIsCharge(transaction)) {
    throw new Error('Transaction is not a charge')
  }
}

export function assertTransactionIsPayment(
  transaction?: Transaction
): asserts transaction is Transaction & { transactionKind: 'payment' } {
  if (!transactionIsPayment(transaction)) {
    throw new Error('Transaction is not a payment')
  }
}
